// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2Tixb","ranges":"BmiRanges_ranges__1f_gB"};